import React from 'react';
import {
  BookOutlined,
  CheckCircleOutlined,
  CloudOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  DollarOutlined,
  FileTextOutlined,
  FilterOutlined,
  IdcardOutlined,
  LockOutlined,
  MessageOutlined,
  RocketOutlined,
  ScheduleOutlined,
  SettingOutlined,
  ShopOutlined,
  SoundOutlined,
  SafetyCertificateOutlined,
  TagsOutlined,
  TeamOutlined,
  ToolOutlined,
  UserSwitchOutlined,
  WalletOutlined,
} from '@ant-design/icons';
import type { FeatureIconKey } from '../content/featureIconTypes';

const ICON_MAP: Record<FeatureIconKey, React.ReactNode> = {
  dashboard: <DashboardOutlined />,
  schedule: <ScheduleOutlined />,
  team: <TeamOutlined />,
  funnel: <FilterOutlined />,
  file: <FileTextOutlined />,
  shop: <ShopOutlined />,
  sound: <SoundOutlined />,
  check: <CheckCircleOutlined />,
  dollar: <DollarOutlined />,
  book: <BookOutlined />,
  message: <MessageOutlined />,
  safety: <SafetyCertificateOutlined />,
  setting: <SettingOutlined />,
  cloud: <CloudOutlined />,
  lock: <LockOutlined />,
  tags: <TagsOutlined />,
  'user-switch': <UserSwitchOutlined />,
  profile: <IdcardOutlined />,
  support: <CustomerServiceOutlined />,
  rocket: <RocketOutlined />,
  customize: <ToolOutlined />,
  wallet: <WalletOutlined />,
};

interface FeatureIconProps {
  iconKey: FeatureIconKey;
  className?: string;
}

const FeatureIcon: React.FC<FeatureIconProps> = ({ iconKey, className }) => (
  <span className={className} aria-hidden>
    {ICON_MAP[iconKey]}
  </span>
);

export default FeatureIcon;
